var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from "~/core/decorator";
import { PageService } from '~/utils/page.service';
import { SortService } from "~/utils/sort.service";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import ViewAttachList from "~/components/common/view-attach-list.vue";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var AnnexInfo = /** @class */ (function (_super) {
    __extends(AnnexInfo, _super);
    function AnnexInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.fileDataSet = [];
        _this.srcList = [];
        _this.fileIds = "";
        return _this;
    }
    AnnexInfo.prototype.queryInfo = function (id) {
        var _this = this;
        this.caseOperatorPageService.queryCaseUploadFile(id, this.pageService, this.sortService).subscribe(function (data) {
            _this.dataSet = data;
            _this.dataSet.forEach(function (item) {
                _this.srcList.push(item.url);
            });
        });
    };
    AnnexInfo.prototype.refreshData = function () {
        this.activated();
    };
    AnnexInfo.prototype.activated = function () {
        if (this.caseId)
            this.queryInfo(this.caseId);
    };
    AnnexInfo.prototype.queryPageInfo = function () {
        if (this.caseId)
            this.queryInfo(this.caseId);
    };
    AnnexInfo.prototype.onClickDelete = function (row) {
        var _this = this;
        this.caseOperatorPageService.deleteCaseUploadFileById(row.id).subscribe(function (data) {
            _this.queryInfo(_this.caseId);
            _this.$message.success('删除成功！');
        });
    };
    __decorate([
        Dependencies(PageService)
    ], AnnexInfo.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AnnexInfo.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], AnnexInfo.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AnnexInfo.prototype, "caseId", void 0);
    AnnexInfo = __decorate([
        Component({
            components: {
                ViewAttachList: ViewAttachList
            },
        })
    ], AnnexInfo);
    return AnnexInfo;
}(Vue));
export default AnnexInfo;
